<div class="login min-vh-100 d-flex flex-column">
  <div class="login-header">
    <div class="container">
      <div class="header py-4">
        <div class="header-logo d-flex align-items-center">
          <img src="/assets/icons/Logo.svg" alt="">
          <span class="ms-3 fs-4 fw-bold text-primblack">
            Improvemath
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="login-body flex-grow-1 d-flex">
    <div class="container d-flex w-100">
      <div class="row w-100 flex-grow-1">
        <div class="d-none d-md-flex col-6 align-items-center">
          <img src="/assets/login_illustration.png" alt="" class="w-100">
        </div>
        <div class="col-12 col-md-6 d-flex flex-column align-items-center justify-content-center">
          <div class="row w-100 justify-content-center">
            <div class="col-12 col-lg-9" [formGroup]="loginForm">
              <h2 class="login-title text-center mb-10 fw-bold">
                Sign in
              </h2>
              <div class="alert alert-{{messageType}} d-flex justify-content-between align-items-center fs-6"
                   role="alert" *ngIf="messageText">
                {{messageText}} <i class="btn-close alert-close" (click)="closeAlert()"></i>
              </div>
              <div class="mb-5">
                <input type="email"
                       class="form-control login-input"
                       id="signin-email"
                       (input)="toLowerCase()"
                       placeholder="Email"
                       formControlName="emailControl">
                <small
                  class="text-danger"
                  *ngIf="loginForm.controls.emailControl.errors?.pattern"
                >
                  Email address is invalid
                </small>
              </div>
              <div class="login-pass mb-5 position-relative">
                <input type="password" class="form-control login-input" id="signin-password"
                       #passInput
                       placeholder="Password"
                       (input)="onPassInput()"
                       formControlName="passControl">
                <div class="login-pass__eye position-absolute icon text-dark d-none"
                     (click)="showPass()"
                     #eye
                >
                  <svg
                    #eyeClose
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-eye-off">
                    <path
                      d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                  <svg
                    #eyeOpen
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-eye d-none">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-10">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label class="form-check-label text-primblack" for="flexCheckDefault">
                    Remember me
                  </label>
                </div>
                <a routerLink="/auth/forgot" class="text-primblack">
                  Forgot Password?
                </a>
              </div>
              <button
                class="btn btn-outline app-btn-black w-100 mb-7"
                [class.disabled]="loginForm.controls.emailControl.errors?.pattern"
                type="button"
                (click)="login()">
                Sign In
              </button>
              <p class="text-primblack text-center mb-15">
                Don’t have an account?
                <a
                  [href]="moreLink"
                  class="text-primblack fw-bold">
                  Learn more
                </a>
              </p>
              <p class="text-center text-primblack fs-6">
                Contact support via:
                <a
                  href="mailto:improvemath.me@supporthelpservice.zendesk.com"
                  class="text-primblack fs-6 fw-bold"
                >
                  improvemath.me@supporthelpservice.zendesk.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
